<div #container class="d-flex flex-column flex-fill h-100 align-items-stretch overflow-hidden"
     [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport,
     'd-none': !hasIntermediaryMeters()}">
    <ng-container>
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <img src="assets/images/icons/meter-tree.png" width="20px" class="me-2">
                <span *ngIf="options.selectedDays.length !== 1">Energy flows</span>
                <span class="mx-2 notranslate">–</span>
                <span>{{ measurementName(options.selectedDataType, true) }}</span>
            </h4>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()">
                <i class="bi bi-arrows-angle-expand"></i>
            </button>
            <app-chart-download-button [element]="container" [tableElement]="tableElement">
                <button chart-download-extra type="button" class="dropdown-item" (click)="downloadVisibleSubmeterData()">
                    <i class="bi bi-file-earmark-excel"></i>
                    <span class="ms-2">Monthly submeter data</span>
                </button>
            </app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()">
                <i class="bi" [ngClass]="options?.meterTreeView?.showAsTable ? 'bi-diagram-3' : 'bi-table'"></i>
            </button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <app-widget-options-menu title="Display settings" [anchorBelowTrigger]="modalOptions.fullScreen">
                <div class="dropdown-item">
                    <div class="row align-items-center mb-2">
                        <label class="form-check-label col-auto" [for]="getInputId('measurementType')+'-select'">
                            Measurement
                        </label>
                        <app-select class="col px-0" [ngModel]="getSelectedDataType" (ngModelChange)="measurementTypeChanged($event)"
                                    [id]="getInputId('measurementType')" [options]="possibleDataTypes()"
                                    [small]="true" [formatter]="dropdownFormatter">
                        </app-select>
                    </div>
                    <div *ngIf="treeData.size > 1" class="row align-items-center">
                        <label class="form-check-label col-auto" for="treeSelect">Connection</label>
                        <app-select class="col px-0" [ngModel]="selectedTreeKey" (ngModelChange)="onTreeChanged($event)"
                                [id]="getInputId('treeSelect')" [options]="treeOptions" [small]="true"
                                [formatter]="treeOptionFormatter" [selectedFormatter]="treeOptionFormatter">
                        </app-select>
                    </div>
                    <div class="row align-items-center mt-2">
                        <label class="form-check-label col-auto" [for]="getInputId('meterName')+'-select'">
                            Show submeters as
                        </label>
                        <app-select class="col px-0" [ngModel]="options?.meterTreeView?.selectedMeterName"
                                    (ngModelChange)="meterNameChanged($event)" [id]="getInputId('meterName')"
                                    [options]="meterNameOptions" [small]="true" [formatter]="meterNameFormatter"
                                    [selectedFormatter]="meterNameFormatter" [optionSelectable]="meterNameSelectable">
                        </app-select>
                    </div>
                </div>
                <app-widget-options-section *ngIf="tagFilters && (tagFilters | keyvalue).length > 0" title="Filters">
                    <div class="dropdown-item">
                        <div class="row align-items-center mb-2"
                             *ngFor="let category of (tagFilters | keyvalue)">
                            <label class="form-check-label col-auto">{{ category.key }}</label>
                            <app-select class="col px-0 notranslate" [ngModel]="options?.meterTreeView?.selectedTagFilters?.[category.key]"
                                        (ngModelChange)="onTagFilterChanged(category.key, $event)"
                                        [options]="category.value" [nullOption]="true"  [small]="true">
                            </app-select>
                        </div>
                    </div>
                </app-widget-options-section>
            </app-widget-options-menu>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 d-flex flex-fill align-items-stretch overflow-hidden"
         [ngClass]="{'p-0': true, 'card-body': !showInReport}">
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
        </ng-container>
        <ng-template #notInReport>
            <div *ngIf="options?.meterTreeView?.showAsTable" class="meter-tree-table-wrapper">
                <table #meterTreeTable class="table table-hover table-bordered m-0 align-middle">
                    <thead class="sticky-top">
                    <tr>
                        <th>Meter</th>
                        <th>Parent meter</th>
                        <th class="text-end">Value</th>
                        <th class="text-end notranslate">{{rootShareLabel}}</th>
                        <th class="text-end">Share of parent</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of selectedTreeTableRows; trackBy: trackTableRow"
                        [class.meter-tree-root-row]="row.level === 0"
                        [class.meter-tree-overlay-row]="row.overlay">
                        <td class="notranslate" [style.padding-left.rem]="1 + row.level * 1.25">
                            <i *ngIf="row.level > 0" class="bi bi-arrow-return-right meter-tree-table-branch"></i>
                            {{row.name}}
                            <span *ngIf="row.overlay" class="meter-tree-overlay-badge">Virtual breakdown</span>
                        </td>
                        <td class="notranslate">{{row.parentName || '—'}}</td>
                        <td class="text-end notranslate">{{tableValue(row)}}</td>
                        <td class="text-end notranslate">{{row.shareOfMainMeter | number:'1.1-1'}}%</td>
                        <td class="text-end notranslate">
                            {{row.shareOfParent == null ? '—' : (row.shareOfParent | number:'1.1-1') + '%'}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <ng-container *ngIf="!options?.meterTreeView?.showAsTable" [ngTemplateOutlet]="chart"></ng-container>
        </ng-template>
    </div>
</div>
<ng-template #chart>
    <div class="meter-tree-chart-shell w-100 h-100 d-flex flex-column overflow-hidden">
        <div *ngIf="!chartOptions.get(selectedTreeKey)"
             class="empty-state text-muted d-flex flex-fill align-items-center justify-content-center">
            No data available for this period
        </div>
        <div class="meter-tree-chart-stage d-flex flex-column flex-fill w-100 overflow-hidden"
             *ngIf="chartOptions.get(selectedTreeKey) as opt">
            <app-tree-chart
                    class="d-block flex-fill w-100 overflow-hidden"
                    [options]="opt"
                    [chartKey]="selectedTreeKey"
                    (chartInit)="onChartInit($event.instance, $event.key)"
                    (chartClick)="handleChartClick($event)">
            </app-tree-chart>
        </div>
    </div>
</ng-template>
